import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation, useMatch } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PublicIcon from "@mui/icons-material/Public";
import "./style.css";
import LogBtn from "../LogBtn";

const SERVICES = [
  {
    to: "/étranger",
    label: "Droit des étrangers",
    description: "Titres de séjour, regroupement familial, nationalité",
    icon: <PublicIcon className="nav-dropdown__icon" />,
  },
];

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef();
  const closeTimer = useRef(null);
  const isServiceActive = useMatch("/étranger");

  const handleDropdownEnter = () => {
    clearTimeout(closeTimer.current);
    setServicesOpen(true);
  };

  const handleDropdownLeave = () => {
    closeTimer.current = setTimeout(() => setServicesOpen(false), 200);
  };

  useEffect(() => {
    setMenuOpen(false);
    setServicesOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
        setServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navItemClass = ({ isActive }) =>
    isActive ? "nav-item nav-item--active" : "nav-item";

  return (
    <nav className="nav" ref={navRef}>
      <div className="nav-frame">
        <NavLink to="/" className="nav-logo-link">
          <img
            src="/images/logocabinet_compress.png"
            className="nav_logo"
            alt="Logo cabinet Maître Camille Doré"
          />
        </NavLink>

        <div className={`nav-links${menuOpen ? " nav-links--open" : ""}`}>
          <NavLink to="/" className={navItemClass} end>
            Accueil
          </NavLink>
          <NavLink to="/apropos" className={navItemClass}>
            À propos
          </NavLink>

          <div
            className="nav-dropdown"
            onMouseEnter={handleDropdownEnter}
            onMouseLeave={handleDropdownLeave}
          >
            <button
              className={`nav-item nav-dropdown__trigger${
                isServiceActive ? " nav-item--active" : ""
              }${servicesOpen ? " nav-dropdown__trigger--open" : ""}`}
              onClick={() => setServicesOpen((o) => !o)}
              aria-expanded={servicesOpen}
              aria-haspopup="true"
            >
              Domaine d'intervention
              <KeyboardArrowDownIcon
                className={`nav-dropdown__arrow${
                  servicesOpen ? " nav-dropdown__arrow--open" : ""
                }`}
              />
            </button>

            <div
              className={`nav-dropdown__menu${
                servicesOpen ? " nav-dropdown__menu--open" : ""
              }`}
              role="menu"
            >
              <p className="nav-dropdown__heading">Domaines d'intervention</p>
              {SERVICES.map((s) => (
                <NavLink
                  key={s.to}
                  to={s.to}
                  className={({ isActive }) =>
                    `nav-dropdown__item${isActive ? " nav-dropdown__item--active" : ""}`
                  }
                  onClick={() => setServicesOpen(false)}
                  role="menuitem"
                >
                  <span className="nav-dropdown__item-icon">{s.icon}</span>
                  <span className="nav-dropdown__item-text">
                    <span className="nav-dropdown__item-label">{s.label}</span>
                    <span className="nav-dropdown__item-desc">{s.description}</span>
                  </span>
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink to="/dashboard" className={navItemClass}>
            Blog
          </NavLink>
          <NavLink to="/contact" className={navItemClass}>
            Contact
          </NavLink>
        </div>

        <div className="nav-actions">
          <LogBtn />
          <button
            className="nav-burger"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
